<template>
  <div class="iconosContainer dropdown-menu" v-if="isOpen && $mq !== 'mobile'">
    <table>
      <tr id="planRow">
        <td class="item" v-for="(item, i) in iconosArriba" :key="i">
          <v-hover v-slot="{ hover }">
            <v-container v-if="!hover" class="icono centered-content" @click="navigate(item.link)">
              <img class="imagen" :src="item.src" />
              <div class="subtituloImg">
                <h5>{{ item.title }}</h5>
              </div>
            </v-container>
            <v-container v-else class="iconoElevated centered-content" @click="navigate(item.link)">
              <img class="imagen" :src="item.src" />
              <div class="subtituloImg">
                <h5>{{ item.title }}</h5>
              </div>
            </v-container>
          </v-hover>
        </td>
      </tr>
    </table>
  </div>
  <div class="iconosContainer" v-else-if="isOpen && $mq === 'mobile'">
    <table>
      <tr id="planRow" v-for="(item, i) in iconosArriba" :key="i">
        <td class="item">
          <v-hover v-slot="{ hover }">
            <v-container v-if="!hover" class="icono centered-content" @click="navigate(item.link)">
              <img class="imagen" :src="item.src" />
              <div class="subtituloImg">
                <h5>{{ item.title }}</h5>
              </div>
            </v-container>
            <v-container v-else class="iconoElevated" @click="navigate(item.link)">
              <img class="imagen" :src="item.src" />
              <div class="subtituloImg">
                <h5>{{ item.title }}</h5>
              </div>
            </v-container>
          </v-hover>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "DropDown",
  data() {
    return {
      isOpen: false,
      test: false,
      windowWidth: window.innerWidth,
      iconosArriba: [
        {
          title: "OFICINA DE TURISMO",
          src: require("../../assets/icons/informacion.png"),
          link: "/oficina",
          resize: false,
          icon: "mdi-information-outline",
        },
        {
          title: "MAPA INTERACTIVO",
          src: require("../../assets/icons/mapainteractivo.png"),
          link: "/mapa",
          icon: "mdi-google-maps",
        },
        {
          title: "DÓNDE DORMIR",
          src: require("../../assets/icons/dormir.png"),
          link: "/dormir",
          icon: "mdi-bed",
        },
        {
          title: "DÓNDE COMER",
          src: require("../../assets/icons/restaurante.png"),
          link: "/comer",
          icon: "mdi-silverware-fork-knife",
        },
        {
          title: "ACTIVIDADES",
          src: require("../../assets/icons/planificador.png"),
          link: "/actividades",
          icon: "",
        },
      ],
    };
  },

  methods: {
    mostrar() {
      this.test = !this.test;
    },
    navigate(link) {
      window.location.href = link;
    },
    getBaseWebUrl() {
      return this.$baseWebUrl;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style>
.subtituloImg h5 {
  font-family: "Amatic SC", cursive;
  padding: 10px 0 0 0;
}
.subtituloImg {
  left: 0 !important;
}

td {
  padding-left: 2.5em;
  padding-right: 2.5em;
  padding-bottom: 1em;
}

.iconosContainer {
  display: table-row;
  /* width: fit-content; */
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: white !important;
  flex-direction: row;
  margin-bottom: 2em;
  cursor: pointer;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  z-index: 1000; /* Agrega esta línea */
}
.dropdown-menu {
  position: absolute;
  top: 100%; /* Coloca el menú debajo del elemento que lo activa */
  left: 0; /* Alinea el menú con el borde izquierdo del elemento que lo activa */
  background-color: white;
  /* Agrega cualquier otro estilo que desees para el menú desplegable */
}

.icono {
  width: 50%;
}

.iconoElevated {
  width: 50%;
}

.centered-content {
  display: flex; /* Utiliza flexbox */
flex-direction: column;
  align-items: center; /* Opcional: Centra verticalmente */
}

td.item {
  width: 20vw;
}

td:hover {
background-color: #d6e0a8;
}

a:link,
a:visited {
  color: black;
  text-decoration: none;
}

a:hover {
  color: red;
}

.subMenu {
  background-color: #d6e0a8;
}

.subtituloImg {
  font-size: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imagen {
  max-width: 100px;
  width: 100%;
  height: auto;
}

.imagenMovil {
  width: 50px;
  height: 50px;
}

.subtituloImgMovil {
  font-size: 0.7em;
}

.enlace {
  display: block;
}

.contenedor {
  padding: 0%;
}

.items {
  background-color: #d6e0a8;
  display: inline;
  padding: 0;
  height: 100%;
}

.listaCont {
  background-color: #d6e0a8;
  padding: 0;
}
</style>
